import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "spinner"]
  
  connect() {
    console.log("[LoadingButton] Controller connected")
    // Reset state on connect (e.g., after Turbo navigation)
    this.hideLoading()
    
    // Listen for turbo events to reset state after form submission
    this.handleTurboComplete = this.handleTurboComplete.bind(this)
    this.handleTurboError = this.handleTurboError.bind(this)
    
    document.addEventListener('turbo:submit-end', this.handleTurboComplete)
    document.addEventListener('turbo:frame-load', this.handleTurboComplete)
    document.addEventListener('turbo:frame-render', this.handleTurboComplete)
    document.addEventListener('turbo:fetch-request-error', this.handleTurboError)
    document.addEventListener('turbo:before-cache', this.handleTurboComplete)
    document.addEventListener('turbo:load', this.handleTurboComplete)
  }
  
  disconnect() {
    document.removeEventListener('turbo:submit-end', this.handleTurboComplete)
    document.removeEventListener('turbo:frame-load', this.handleTurboComplete)
    document.removeEventListener('turbo:frame-render', this.handleTurboComplete)
    document.removeEventListener('turbo:fetch-request-error', this.handleTurboError)
    document.removeEventListener('turbo:before-cache', this.handleTurboComplete)
    document.removeEventListener('turbo:load', this.handleTurboComplete)
  }
  
  handleTurboComplete(event) {
    console.log("[LoadingButton] Turbo completed, hiding loading state")
    // Reset the loading state when the form submission completes
    this.hideLoading()
  }
  
  handleTurboError(event) {
    console.log("[LoadingButton] Turbo error, hiding loading state")
    // Reset the loading state on error
    this.hideLoading()
  }
  
  // Generic method to show loading state for any button
  showLoading(event) {
    console.log("[LoadingButton] Showing loading state")
    const button = event.currentTarget
    
    // Set button as disabled and add aria-busy for accessibility
    button.disabled = true
    button.setAttribute('aria-busy', 'true')
    
    // Hide text and show spinner for this button
    if (this.hasTextTarget) {
      this.textTarget.style.display = 'none'
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
      this.spinnerTarget.style.display = 'inline-flex'
    }
    
    // Add visual disabled state
    button.classList.add('opacity-50', 'cursor-not-allowed')
    
    // Don't prevent the default action - let the form submit
  }
  
  hideLoading() {
    console.log("[LoadingButton] Hiding loading state")
    
    // Re-enable button
    const button = this.element
    if (!button) return
    
    button.disabled = false
    button.removeAttribute('aria-busy')
    
    // Show text and hide spinner
    if (this.hasTextTarget) {
      this.textTarget.style.display = ''
      this.textTarget.classList.remove('hidden')
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
      this.spinnerTarget.style.display = 'none'
    }
    
    // Remove visual disabled state
    button.classList.remove('opacity-50', 'cursor-not-allowed')
  }
  
  // Special method for Generate PDF buttons that syncs ALL buttons
  handleClick(event) {
    console.log("[LoadingButton] Generate PDF clicked - syncing all Generate PDF buttons")
    console.log("[LoadingButton] Button:", event.currentTarget)
    console.log("[LoadingButton] Form:", event.currentTarget.form)
    
    // Update ALL Generate PDF buttons on the page immediately
    this.syncAllButtons()
    
    // Don't prevent the click - let the form submit naturally
    // The UI is already updated, so the user sees the spinner
  }
  
  syncAllButtons() {
    console.log("[LoadingButton] Synchronizing all Generate PDF buttons")
    
    // Hide ALL text elements with loading button targets
    document.querySelectorAll('[data-oms--oms--loading-button-target="text"]').forEach(el => {
      el.style.display = 'none'
    })
    
    // Show ALL spinner elements with loading button targets  
    document.querySelectorAll('[data-oms--oms--loading-button-target="spinner"]').forEach(el => {
      el.style.display = 'inline-flex'
    })
    
    // Add visual disabled state but DON'T actually disable the button (that prevents form submission)
    // We'll disable it after a short delay to allow the form to submit
    document.querySelectorAll('button[type="submit"]').forEach(button => {
      if (button.textContent.includes('Generate PDF')) {
        button.classList.add('opacity-50', 'cursor-not-allowed')
        button.setAttribute('aria-busy', 'true')
        // Disable after a small delay to allow form submission
        setTimeout(() => {
          button.disabled = true
        }, 100)
      }
    })
  }
}